import { isbot } from 'isbot';

/**
 * Bot detection utility.
 *
 * Delegates to the maintained `isbot` library (a continuously-updated UA list) rather than a
 * hand-maintained regex. `WebPageTest` is added on top: it is a real bot seen in our Datadog logs
 * that `isbot` does not classify (it presents as a normal Chrome UA with a `WebPageTest` suffix).
 */
const ADDITIONAL_BOT_PATTERN = /WebPageTest/i;

/**
 * Detects if the current browser is a bot based on the User-Agent string.
 * @returns true if a bot is detected, false otherwise
 */
export const isBotUserAgent = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';
  return isbot(userAgent) || ADDITIONAL_BOT_PATTERN.test(userAgent);
};
